/**
 * Form Common Component
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DirectivesModule } from '@app/components/directives/directives.module';

import { COMPONENTS } from './form-common.componets';

@NgModule({
  imports: [CommonModule, FormsModule, DirectivesModule],
  exports: [ReactiveFormsModule, ...COMPONENTS],
  declarations: [...COMPONENTS],
})
export class FormCommonModule {}
